import { Component, Input } from '@angular/core';

@Component({
    selector: 'sgt-pacote-campanha-label',
    templateUrl: './pacote-campanha-label.component.html',
    styleUrls: ['./pacote-campanha-label.component.less']
})
export class PacoteCampanhaLabelComponent {
    @Input() nome: string;
    @Input() fontSize = '12px';
}
